import React, { useEffect, useState } from 'react';
import { useAuth } from '../../../../../../hooks/auth';
import { useToast } from '../../../../../../hooks/toast';
import api from '../../../../../../services/api';
import * as S from './styles';
import Button from '../../../../../../newComponents/Button';
import Select from '../../../../../../newComponents/Select';

interface IOption {
  id: string;
  value: string;
  label: string;
}

const viewModeOptions: IOption[] = [
  { id: '0', value: 'food', label: 'Alimentação' },
  { id: '1', value: 'store', label: 'Varejo' },
];

const ViewMode: React.FC = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [selectedOption, setSelectedOption] = useState<IOption>(
    viewModeOptions[0],
  );
  const { addToast } = useToast();
  const { user } = useAuth();

  const handleSubmitViewMode = async (): Promise<void> => {
    setIsLoading(true);
    try {
      await api.post(`/parametro`, {
        descricao: 'view_mode',
        empresa_id: user.empresa_id,
        role: JSON.stringify({
          value: selectedOption.value,
        }),
      });

      addToast({
        title: `Alterações feitas com sucesso!`,
        type: 'success',
      });
      setIsLoading(false);
    } catch (err) {
      addToast({
        title: 'Algo deu errado',
        type: 'error',
        description: (err as any).response?.data?.message || 'Tente novamente.',
      });
      setIsLoading(false);
    }
  };

  useEffect(() => {
    async function loadViewMode(): Promise<void> {
      try {
        const response = await api.get('/parametro', {
          params: {
            descricao: 'view_mode',
            empresa_id: user.empresa_id,
          },
        });

        if (response.data) {
          const role = JSON.parse(response.data.role);

          setSelectedOption(
            viewModeOptions.find((item) => item.value === role.value)!,
          );
        }

        setIsLoading(false);
      } catch (err) {
        addToast({
          title: 'Algo deu errado',
          type: 'error',
          description:
            (err as any).response?.data?.message || 'Tente novamente.',
        });
        setIsLoading(false);
      }
    }

    loadViewMode();
  }, [addToast, user.empresa_id]);

  return (
    <S.Container>
      <div className="header">
        <h2>Modo de visualização</h2>
        <p>
          Defina o modo de visualização que mais se adequa com o seguimento da
          sua loja
        </p>
      </div>

      <div className="body">
        <Select
          name="Limitacao"
          value={selectedOption}
          disabled={isLoading}
          options={viewModeOptions}
          onChange={(value: any) => setSelectedOption(value)}
        />

        <Button disabled={isLoading} full onClick={handleSubmitViewMode}>
          Salvar
        </Button>
      </div>
    </S.Container>
  );
};

export default ViewMode;
